import angular from 'angular';

const THEME_DEFAULT = 'default';
const THEME_DARK = 'dark';
const THEME_SYSTEM = 'system';

export default class ThemeService {
    /* @ngInject */
    constructor($window, $document) {
        this.$window = $window;
        this.$document = $document;
        this.theme = THEME_DEFAULT;

        this.mediaQuery = this.$window.matchMedia
            ? this.$window.matchMedia('(prefers-color-scheme: dark)')
            : null;

        this.handleSystemChange = this.handleSystemChange.bind(this);

        if (this.mediaQuery) {
            if (this.mediaQuery.addEventListener) {
                this.mediaQuery.addEventListener('change', this.handleSystemChange);
            } else if (this.mediaQuery.addListener) {
                this.mediaQuery.addListener(this.handleSystemChange);
            }
        }

        this.applyTheme(this.getStoredTheme() || THEME_DEFAULT);
    }

    getStoredTheme() {
        try {
            return this.$window.localStorage.getItem('theme') || null;
        } catch (error) {
            return null;
        }
    }

    applyTheme(theme) {
        this.theme = theme || THEME_DEFAULT;
        const resolved = this.resolveTheme(this.theme);
        this.setThemeAttribute(resolved);
        this.persistTheme(this.theme);
        this.persistResolvedTheme(resolved);
    }

    resolveTheme(theme) {
        if (theme === THEME_SYSTEM) {
            return this.mediaQuery && this.mediaQuery.matches ? THEME_DARK : THEME_DEFAULT;
        }

        return theme === THEME_DARK ? THEME_DARK : THEME_DEFAULT;
    }

    setThemeAttribute(theme) {
        const body = angular.element(this.$document[0].body);
        const root = angular.element(this.$document[0].documentElement);
        body.attr('data-theme', theme);
        root.attr('data-theme', theme);

        const inlineStyle = this.$document[0].querySelector('style[data-theme-inline="true"]');
        if (inlineStyle && inlineStyle.parentNode) {
            inlineStyle.parentNode.removeChild(inlineStyle);
        }
    }

    persistTheme(theme) {
        try {
            this.$window.localStorage.setItem('theme', theme);
        } catch (error) {
            // ignore storage failures (private mode, disabled storage, etc.)
        }
    }

    handleSystemChange() {
        if (this.theme === THEME_SYSTEM) {
            this.applyTheme(THEME_SYSTEM);
        }
    }

    persistResolvedTheme(theme) {
        try {
            this.$window.localStorage.setItem('theme_resolved', theme);
        } catch (error) {
            // ignore storage failures
        }
    }
}

export { THEME_DEFAULT, THEME_DARK, THEME_SYSTEM };



// WEBPACK FOOTER //
// ./src/application/service/theme.service.js